import styles from "./Header.module.css";

const Header = (props) => {
  return <section className={styles.content}>{props.children}</section>;
};

export default Header;
